import { PayoutConfig } from "./payoutConfig";
import { PointSeries } from "./point-series";

export class ProgressionTieBreaker {
    id: number;
    progressionId: number;

    payoutConfig: PayoutConfig;
    payoutConfigId: number;

    pointSeries: PointSeries;
    pointSeriesId: number;
    
    breakByTimeScore: boolean;
    breakByTotalTimeScore: boolean;
    breakByPointSeriesPlace: boolean;
    breakByAthleteScore: boolean;
    breakByCombinedAthleteScore: boolean;
    breakByRideTime: boolean;
    
    round: number;
    
    priorityOrder: number;

    constructor() {
        this.breakByTimeScore = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/progression-tiebreaker.ts